export default __webpack_public_path__ + "static/media/gcmptalogo_bgnone.60f2c7ea.png";